<template>
  <v-card class="my-4 dia-mes-mais-frequente">
    <v-card-title>
      <span class="pa-1 table-card-title">Dia do mês mais frequente de compra</span>
    </v-card-title>
    <div class="data-box">
      <mf-loading loader="dias-compras" loader-type="dynamic" :dynamicAmount="8" :dynamicWidth="200">
        <v-data-table :headers="headers" :items="items" hide-default-footer disable-pagination>
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-left">{{ item['NUM_DIA'] }}</td>
              <td class="text-right">{{ item['NUM_TOTAL_CUPONS'] | abreviation({ isInteger: true }) }}</td>
            </tr>
          </template>
        </v-data-table>
      </mf-loading>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    items: Array,
  },
  computed: {
    headers() {
      return [
        {
          text: 'Dia',
          value: 'NUM_DIA',
          align: 'left',
        },
        {
          text: 'Cupons',
          value: 'NUM_TOTAL_CUPONS',
          align: 'right',
        },
      ]
    },
  },
}
</script>

<style lang="scss">
.dia-mes-mais-frequente {
  height: 330px !important;
  overflow: hidden;
  .data-box {
    overflow-y: scroll;
    height: 80%;
  }
}
</style>
